import { useSelector } from "react-redux";

import { Box, Logo } from "@seneca/senekit";
import { LogoVariant } from "@seneca/senekit/out/components/content/Logo/consts";

import { getAppName, useIsPlurallApp } from "features/plurall";
import { getRegion } from "features/regions/selectors";

import { getAppVersion } from "../utils/functions/app";

export default function TeacherLogo() {
  const region = useSelector(getRegion);
  const isPlurallApp = useIsPlurallApp();

  const title = `${getAppName()} ${getAppVersion()}`;

  const { variant, text } = REGION_VARIANTS[region!] || REGION_VARIANTS["GB"];

  return (
    <Box title={title}>
      <Logo
        variant={isPlurallApp ? "plurall" : variant}
        text={isPlurallApp ? undefined : text}
        height={["36px", "40px"]}
        textSize="xsmall"
      />
    </Box>
  );
}

const REGION_VARIANTS: {
  [key: string]: { variant: LogoVariant; text: string | undefined };
} = {
  BR: {
    variant: "goStudent",
    text: "PARA PROFESSORES"
  },
  FR: {
    variant: "goStudent",
    text: "LES PROFESSEURS"
  },
  MX: {
    variant: "goStudent",
    text: "PARA PROFESORES"
  },
  CO: {
    variant: "goStudent",
    text: "PARA PROFESORES"
  },
  GB: {
    variant: "default",
    text: "FOR TEACHERS"
  },
  DE: {
    variant: "goStudent",
    text: "FÜR LEHRKRÄFTE"
  },
  AT: {
    variant: "goStudent",
    text: "FÜR LEHRKRÄFTE"
  }
};
